import React from "react";
import PropTypes from "prop-types";
import CameraQuestionPreface from "./CameraQuestionPreface";
import C from "../../constants";
import Camera, { IMAGE_TYPES, FACING_MODES } from "react-html5-camera-photo";

const CameraQuestion = ({ question = {}, store = {}, processDeviceInput = f => f, processClick = f => f }) => {
    if (!question.cameraVisible) {
        return (
            <CameraQuestionPreface
                question={question}
                store={store}
                selectionMade={option => {
                    processClick(
                        option.action,
                        option.actionState,
                        option.hasOwnProperty("nextQuestion") ? option.nextQuestion : undefined
                    );
                }}
                processDeviceInput={processDeviceInput}
            />
        );
    } else {
        return (
            <div class="camera">
                <Camera
                    onTakePhoto={dataUri => processDeviceInput(dataUri)}
                    imageType={IMAGE_TYPES.JPG}
                    idealFacingMode={FACING_MODES.ENVIRONMENT}
                    isImageMirror={false}
                    idealResolution={{ width: 1920, height: 1080 }}
                    isMaxResolution={false}
                />
                <button onClick={() => processClick(C.HIDE_CAMERA, {})}>CANCEL</button>
            </div>
        );
    }
};

CameraQuestion.propTypes = {
    question: PropTypes.object,
    processDeviceInput: PropTypes.func,
    processClick: PropTypes.func
};

export default CameraQuestion;
